var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from "react";
import ReportValue from "../../../../../../../shared-library/components/commonTableVal";
import EdModal from "@frameworks/web/components/generic/edModal";
import CashEquivalent from "./CashEquivalent";
import { useSelector } from "react-redux";
import di from "@frameworks/salesjourney/components/Features/ClientDetails/di/serviceLocator";
import moment from "moment";
var ChargesTable = function (props) {
    var _a = __read(React.useState([false]), 2), openAcc = _a[0], setOpenAcc = _a[1];
    var _b = __read(React.useState(false), 2), cashEq = _b[0], setCashEq = _b[1];
    var _c = __read(React.useState(), 2), availableCash = _c[0], setAvailableCash = _c[1];
    var _d = __read(React.useState([]), 2), availableCashEquivilent = _d[0], setAvailableCashEquivilent = _d[1];
    var _e = __read(React.useState(false), 2), fnoLoader = _e[0], setFnoLoader = _e[1];
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var getFNOAvailableCashDetails = function (txndate) { return __awaiter(void 0, void 0, void 0, function () {
        var fNOPayloads;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    fNOPayloads = {
                        accode: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode,
                        FromDate: moment(txndate).format("YYYY-DD-MM"),
                        TxnYear: txndate.slice(6, 10),
                        dataFrom: "EQ",
                    };
                    return [4 /*yield*/, di.clients
                            .getFNOAvailableCashData(fNOPayloads)
                            .then(function (availableCashResponse) {
                            setAvailableCashEquivilent(availableCashResponse);
                            //setFnoLoader(false);
                        })
                            .catch(function (error) {
                            console.log("fno available cash error", error);
                            //setFnoLoader(false);
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    // const dpcData = [
    //   {
    //     month: "February - 2018",
    //     amount: "10460.62",
    //     details: [
    //       {
    //         t_date: "21 Feb 2018",
    //         margin: "39,457.64",
    //         ex_margin: "39,457.64",
    //         cash_margin: "39,457.64",
    //         cash_eq: "39.6",
    //         dpc_amount: "68,705.97",
    //         dpc_charges: "12",
    //         dpc_day: "22.59",
    //       },
    //       {
    //         t_date: "21 Feb 2018",
    //         margin: "39,457.64",
    //         ex_margin: "39,457.64",
    //         cash_margin: "39,457.64",
    //         cash_eq: "39.6",
    //         dpc_amount: "68,705.97",
    //         dpc_charges: "12",
    //         dpc_day: "22.59",
    //       },
    //     ],
    //   },
    //   {
    //     month: "February - 2018",
    //     amount: "10460.62",
    //     details: [
    //       {
    //         t_date: "21 Feb 2018",
    //         margin: "39,457.64",
    //         ex_margin: "39,457.64",
    //         cash_margin: "39,457.64",
    //         cash_eq: "39.6",
    //         dpc_amount: "68,705.97",
    //         dpc_charges: "12",
    //         dpc_day: "22.59",
    //       },
    //       {
    //         t_date: "21 Feb 2018",
    //         margin: "39,457.64",
    //         ex_margin: "39,457.64",
    //         cash_margin: "39,457.64",
    //         cash_eq: "39.6",
    //         dpc_amount: "68,705.97",
    //         dpc_charges: "12",
    //         dpc_day: "22.59",
    //       },
    //     ],
    //   },
    // ];
    return (React.createElement(React.Fragment, null,
        props.revenueDetails &&
            props.revenueDetails.length > 0 &&
            props.revenueDetails.map(function (dpc, idx) {
                return (React.createElement("div", { key: idx, className: "charges-table ".concat(openAcc[idx] ? "openAccmain" : "") },
                    React.createElement("div", { className: "table common-table " },
                        React.createElement("div", { className: "profile-main-tablebody-tr  d-flex align-items-center justify-content-between py-3 px-2 ".concat(openAcc[idx] ? "openAcc" : "") },
                            React.createElement("div", null,
                                React.createElement("span", { className: "hand_cursor" },
                                    React.createElement("i", { className: openAcc[idx]
                                            ? "edel-icon-arrow-up"
                                            : "edel-icon-arrow-down", onClick: function () {
                                            var temp = __spreadArray([], __read(openAcc), false);
                                            temp[idx] = !temp[idx];
                                            setOpenAcc(temp);
                                        } })),
                                React.createElement("span", { className: "arrowicon-td DMSan_14_500" }, dpc.dpcMonth)),
                            React.createElement("div", null,
                                React.createElement(ReportValue, { stream: false, onlyval: false, showZero: true, val: dpc.value, parentClass: "RobotoM_14_500" }))),
                        openAcc[idx] && (React.createElement("table", null,
                            React.createElement("thead", { className: "DMSansMedium_12_500 txt_primaryGrey" },
                                React.createElement("td", null, "Transaction Date"),
                                React.createElement("td", null,
                                    "Exchange Margin",
                                    React.createElement("br", null),
                                    " Requirement"),
                                React.createElement("td", null,
                                    "50% of Exchange ",
                                    React.createElement("br", null),
                                    " Margin Requirement"),
                                React.createElement("td", null, "Available Cash Margin"),
                                React.createElement("td", null,
                                    "Available Cash",
                                    React.createElement("br", null),
                                    " Equivalent"),
                                React.createElement("td", null,
                                    "DPC Chargeable",
                                    React.createElement("br", null),
                                    " Amt (Rs)"),
                                React.createElement("td", null, "DPC Charges Per"),
                                React.createElement("td", null, "DPC PerDay")),
                            React.createElement("tbody", null, dpc.fnoMonthwiseDetails &&
                                dpc.fnoMonthwiseDetails.length > 0 &&
                                dpc.fnoMonthwiseDetails.map(function (subList, idx) {
                                    return (React.createElement("tr", { key: idx, className: "DMSanM_14_500 txt_blackOne1" },
                                        React.createElement("td", null, subList.trxdate),
                                        React.createElement("td", null, subList.exchngMarginReq),
                                        React.createElement("td", null, subList.halfExchngMarginReq),
                                        React.createElement("td", null, subList.availableCashMargin),
                                        React.createElement("td", { className: "text-decoration-underline txt-midnight-blue hand_cursor", onClick: function () {
                                                setCashEq(true);
                                                setAvailableCash(subList);
                                                getFNOAvailableCashDetails(subList.trxdate);
                                            } }, subList.availableCashEQ),
                                        React.createElement("td", null, subList.dpcChargeableAmount),
                                        React.createElement("td", null, subList.dpcChargesPercentage),
                                        React.createElement("td", null, subList.dpcPerday)));
                                })))))));
            }),
        React.createElement(EdModal, { show: cashEq, setShow: setCashEq, showFooter: false, modalTitle: "sales-client commonmodal charges", children: React.createElement(CashEquivalent, { availableDetails: availableCashEquivilent }), title: "Available Cash Equivalent" })));
};
export default ChargesTable;
